// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"51":"18ca12c8","79":"fb30f649","156":"ee9a2fd8","186":"2f499029","215":"d8d48148","507":"28577440","879":"eb794722"}[chunkId] + ".chunk.css";
};